/* global axios */
import ApiClient from '../ApiClient';

class SocialMonitoringReportsAPI extends ApiClient {
  constructor() {
    super('social_monitoring/reports', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  list({ profileId } = {}) {
    return axios.get(this.url, { params: { profileId } });
  }

  generate({ profileId, days, platform }) {
    return axios.post(this.url, { profileId, days, platform });
  }
}

export default new SocialMonitoringReportsAPI();
